import { Components, Theme } from '@mui/material/styles';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    root: ({ theme }) => ({}),

    inputRoot: {
      height: '42px',
      fontSize: '12px',
      '& > fieldset': {
        borderRadius: '3px',
      },
      '&.Mui-disabled': {
        cursor: 'not-allowed',
        '& > fieldset': {
          borderColor: 'var(--palette-background-disabled) !important',
        },
      },
    },

    input: {
      fontSize: '12px',
      padding: '0 !important',
    },

    listbox: {
      overflow: 'hidden',
      maxHeight: 'unset',
    },

    option: {
      '&:hover': {
        backgroundColor: 'color-mix(in srgb, var(--palette-action-hover) 30%, transparent)',
      },
      '&.Mui-focused': {
        backgroundColor: 'color-mix(in srgb, var(--palette-action-hover) 10%, transparent)',
      },
    },

    paper: {
      maxHeight: 190,
    },
  },
};
